export default "__VITE_ASSET__Bg3kFWWH__"